
import * as React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

const Copyright = (props) => {
    return (
      <Typography variant="body2" color="text.secondary" align="center" sx={{pt:4}}>
      <Link  color="inherit" style={{ textDecoration: 'none', cursor:"pointer" }} onClick={() => { props.mainNavClick("Terms")}} >
         Privacy, Terms & Conditions - 
        {' Copyright © '}
          ICPipeline
        {' '}
        {new Date().getFullYear()}
        {'. '}
        </Link>
      </Typography>
    );
  }// end Copyright

  export default Copyright ;
  